import { Query } from '@farfetched/core';
import { createEvent, EventCallable, sample } from 'effector';
import { BetReportRegistryModel } from 'entities/bet';
import { createDownloadBetReportQuery, DownloadBetReportQueryParams } from 'shared/api';

export type ExportReportBetsModel = {
	exportButtonClicked: EventCallable<void>;
	downloadBetReportQuery: Query<DownloadBetReportQueryParams, void, unknown, null>;
};

export const createExportReportBetsModel = (
	model: BetReportRegistryModel,
): ExportReportBetsModel => {
	const downloadBetReportQuery = createDownloadBetReportQuery();

	const exportButtonClicked = createEvent();

	sample({
		clock: exportButtonClicked,
		source: model.registryModel.$filters,
		fn: (filters) => filters,
		target: downloadBetReportQuery.start,
	});

	return {
		downloadBetReportQuery,
		exportButtonClicked,
	};
};
